<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Authorizations</h1>
            <div class="action">
                <ppl-button label="View Spending Plans" icon="fa fa-sitemap" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="onViewSpendingPlans()"></ppl-button>
                @if(!isReadOnly){
                <ppl-button label="Add Authorizations" icon="fa fa-plus" [customClass]="'primary-button'" [styleString]="'margin-left: 8px;'"
                    [iconPosition]="'left'" (click)="onAddAuthorizations()" [authorizeButton]="[pageId, 'AddAuthorizations']"></ppl-button>
                }
            </div>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="table-style">
                    <ppl-list-table [pageConfig]="programName" [sharedDataKey]="sharedDataKey" (rowDetailEvent)="rowClicked($event)" [loadPage]="lazyLoad" (actionInvoked)="cloneAuthorization($event)"
                        [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
                        [enablePageActions]="true"
                        [jsonList]="'list_authorizations'"
                        [badgeColumns]="['Status', 'Deactivated']"
                        rowDataAccessibilityKey="clientAuth"
                        (dataReceived)="onDataReceived($event)">
                    </ppl-list-table>
                </div>
            </div>
        </div>
    </div>
    }

</ng-container>
